import http from './_http'

const login = {
  get: (id) => http.get(`api.user/log/login/${id}`),
  list: (m) => http.post(`api.user/log/logins/search`, m),
}
const action = {
  get: (id) => http.get(`api.user/log/action/${id}`),
  list: (m) => http.post(`api.user/log/actions/search`, m),
}
const system = {
  get: (id) => http.get(`api.user/log/system/${id}`),
  list: (m) => http.post(`api.user/log/systems/search`, m),
}
const mail = {
  get: (id) => http.get(`api.user/log/mail/${id}`),
  list: (m) => http.post(`api.user/log/mails/search`, m),
}

const log  = {
  login, action, system, mail
}
export default log
export { login, action, system, mail }